// extracted by mini-css-extract-plugin
export default {"container":"errorpage_container__ZnGCA","errorImage":"errorpage_errorImage__bq-my","errorPageBtn":"errorpage_errorPageBtn__09HpV"};